// extracted by mini-css-extract-plugin
module.exports = {"navSlider":"_f0d8de5","mainSlider":"_de2001e","navArrows":"_5738f2d"};